/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * usePublicViewTypes — fetch the list of available public view types.
 */

import { useQuery } from '@tanstack/react-query';
import APIHelper from '../api/APIHelper';
import envConfig from '../config/envConfig';

const apiHelper = new APIHelper({
  apiUrl: envConfig.backendApiUrl,
  tokenUrl: envConfig.backendTokenUrl,
  clientId: envConfig.clientKey,
  clientSecret: envConfig.clientSecret,
});

export function usePublicViewTypes() {
  return useQuery({
    queryKey: ['publicViewTypes'],
    queryFn: async ({ signal }) => {
      const resp = await apiHelper.apiCall(
        '/arcee/application/public-view-types/',
        { method: 'GET', signal }
      );
      if (!resp.ok) {
        let body = {};
        try { body = await resp.json(); } catch (_) {}
        throw new Error(body.error || body.message || `Failed to load view types (${resp.status})`);
      }
      return resp.json();
    },
    staleTime: 300_000, // view types rarely change
    retry: 1,
  });
}
